import EpcrNotes from "./EpcrNotes";
import EpcrInjuries from "./EpcrInjuries";
import EpcrCustomPanel from "./EpcrCustomPanel";
import EpcrDetails from "./EpcrDetails";
import EpcrNarrative from "./EpcrNarrative";
import EpcrHistory from "./EpcrHistory";
import EpcrVitals from "./EpcrVitals"
import EpcrOutcome from "./EpcrOutcome";
import EpcrTreatment from "./EpcrTreatment"
import { EpcrQuickSearch } from "./EpcrQuickSearch";
import EpcrMedication from "./medication/EpcrMedication";
import EpcrLegacyTreatment from "./EpcrLegacyTreatment";

export const buildEpcrTabs = (t, clientConfig) => {
    let tabs = [
        {
            label: t('quickSearch'),
            id: 'quickSearch',
            icon: { variant: 'solid', kind: 'magnifying-glass'},
            search: true,
            render: (disabled) => <EpcrQuickSearch disabled={disabled}></EpcrQuickSearch>
        },
        {
            label: t('patient'),
            icon: { variant: 'solid', kind: 'user' },
            id: 'details',
            simple: true,
            search: true,
            edit: true,
            render: (disabled) => <EpcrDetails disabled={disabled}></EpcrDetails>
        },
        {
            label: t('narrative'),
            icon: { variant: 'solid', kind: 'pencil' },
            id: 'narrative',
            simple: true,
            edit: true,
            search: true,
            render: (disabled) => <EpcrNarrative disabled={disabled}></EpcrNarrative>
        },
        {
            label: t('history'),
            icon: { variant: 'solid', kind: 'table-list' },
            id: 'history',
            simple: true,
            edit: true,
            render: (disabled) => <EpcrHistory disabled={disabled}></EpcrHistory>
        },
        {
            label: t('vital_other'),
            icon: { variant: 'regular', kind: 'heart' },
            id: 'vitals',
            simple: false,
            edit: true,
            render: (disabled) => <EpcrVitals disabled={disabled}></EpcrVitals>
        }
    ];
    if (clientConfig.epcrLegacyTreatment) {
        tabs = tabs.concat([
            {
                label: t('treatments'),
                icon: { variant: 'solid', kind: 'crutch' },
                id: 'treatment',
                simple: true,
                edit: true,
                render: (disabled) => <EpcrLegacyTreatment disabled={disabled}></EpcrLegacyTreatment>
            }
        ]);
    } else {
        tabs = tabs.concat([{
            label: t('medication_other'),
            icon: { variant: 'solid', kind: 'prescription-bottle-medical' },
            id: 'medication',
            simple: true,
            edit: true,
            render: (disabled) => <EpcrMedication disabled={disabled}></EpcrMedication>
        },
        {
            label: t('treatments'),
            icon: { variant: 'solid', kind: 'crutch' },
            id: 'treatment',
            simple: true,
            edit: true,
            render: (disabled) => <EpcrTreatment disabled={disabled}></EpcrTreatment>
        }]);
    }
    tabs = tabs.concat([
        {
            label: t('outcome'),
            icon: { variant: 'solid', kind: 'right-from-bracket' },
            id: 'outcome',
            simple: true,
            edit: true,
            search: true,
            render: (disabled) => <EpcrOutcome disabled={disabled}></EpcrOutcome>
        },
        {
            label: t('audit'),
            icon: { variant: 'solid', kind: 'align-justify' },
            id: 'log',
            simple: true,
            edit: true,
            render: (disabled) => <EpcrNotes disabled={disabled}></EpcrNotes>
        }
    ]);
    if (clientConfig.epcrBodyForm) {
        tabs.splice(3, 0, {
            label: t('injuries'),
            icon: { variant: 'solid', kind: 'user' },
            id: 'injuries',
            simple: false,
            edit: true,
            search: true,
            render: (disabled) => <EpcrInjuries disabled={disabled}></EpcrInjuries>
        });
    };
    if (clientConfig.epcrRefusalFormSpec) {
        tabs.splice(clientConfig.epcrLegacyTreatment ? 6 : 7, 0, {
            label: t("refusal"),
            icon: { variant: 'solid', kind: 'ban' },
            id: "refusal",
            simple: true,
            edit: true,
            search: true,
            render: (disabled) => <EpcrCustomPanel formdef={clientConfig.epcrRefusalFormSpec} disabled={disabled} ></EpcrCustomPanel>
        })
    };
    if (clientConfig.epcrAdditionalTabs) {
        tabs.splice(clientConfig.epcrLegacyTreatment ? 6 : 7, 0, ...clientConfig.epcrAdditionalTabs.map(tab => ({
            label: tab.label,
            icon: { ...tab.icon },
            id: tab.id,
            simple: tab.simple,
            edit: true,
            search: true,
            render: (disabled) => <EpcrCustomPanel formdef={tab.formdef} disabled={disabled}></EpcrCustomPanel>
        })))
    }
    if (clientConfig.epcrCaseFormSpec) {
        tabs.splice(1, 0, {
            label: t("caseDetails"),
            icon: { variant: 'solid', kind: 'briefcase-medical' },
            id: "case",
            simple: true,
            edit: true,
            search: true,
            render: (disabled) => <EpcrCustomPanel formdef={clientConfig.epcrCaseFormSpec} disabled={disabled}></EpcrCustomPanel>
        })
    };
    if (clientConfig.epcrTabOrder) {
        return clientConfig.epcrTabOrder.map(tab => {
            if (typeof tab === 'string') {
                return tabs.find(t => t.id === tab)
            } else {
                const { id, ...props } = tab;
                return { ...tabs.find(t => t.id === id), ...props }
            }
        }).filter(Boolean);
    }
    return tabs;
}